import {GenericoTipoEnum} from "../../bibliotecaPjus/enums/enumGenerico.enum";

export enum TipoBoolPreenchido {
  NaoSelecionado = 'NaoSelecionado',
  Sim = 'Sim',
  Nao = 'Nao',
}

export class TipoBoolPreenchidoEnum extends GenericoTipoEnum<TipoBoolPreenchido> {
  static readonly NaoSelecionado = new TipoBoolPreenchidoEnum(TipoBoolPreenchido.NaoSelecionado, 'Não Selecionado');
  static readonly Sim = new TipoBoolPreenchidoEnum(TipoBoolPreenchido.Sim, 'Sim');
  static readonly Nao = new TipoBoolPreenchidoEnum(TipoBoolPreenchido.Nao, 'Não');
}
